import { useField } from 'formik';
import { DeliveryTypeCard } from '../delivery-type-card';

type TDeliveryTypeCartFieldProps = {
  name: string;
  price: number;
  title: string;
  isDisabled?: boolean;
  value: string;
};

export const DeliveryTypeCartField = ({
  name,
  isDisabled,
  price,
  title,
  value,
}: TDeliveryTypeCartFieldProps): JSX.Element => {
  const [, meta, helpers] = useField(name);
  const isChecked = meta.value === value;

  const handleChange = (newCalue: string): void => {
    helpers.setValue(newCalue);
  };

  return (
    <DeliveryTypeCard
      isChecked={isChecked}
      isDisabled={isDisabled}
      onChange={handleChange}
      value={value}
      name={name}
      price={price}
      title={title}
    />
  );
};
